var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { getDatasets } from "../results/fetchDcData";
export function jobIdToDatasetid(jobid, userId, project) {
    return __awaiter(this, void 0, void 0, function* () {
        const group = `${userId}/${project}`;
        const datasets = yield getDatasets({
            useronly: true,
            startswith: `${group}/`,
            group: group,
            execid: jobid,
        });
        if (!datasets)
            return;
        if (datasets.length === 0) {
            console.error("Dataset id not found");
            return;
        }
        return datasets[0]["id"];
    });
}
